export const getFileNameFromPath = (path: string) => {
  const pathArray = path.split("/");
  return pathArray[pathArray.length - 1];
};

export const isFile = (name: string) => {
  return getFileNameFromPath(name).split(".").pop();
};

export const downloadOvpnFile = (fileContent: string) => {
  const element = document.createElement("a");
  const file = new Blob([fileContent], { type: "text/plain" });
  element.href = URL.createObjectURL(file);
  element.download = "hotspring.ovpn";
  element.click();
};
